import { Stripe, StripeElements } from "@stripe/stripe-js";
import { connect } from "react-redux";

import {
  createSubscriptionErrored,
  createSubscriptionErrorMessage
} from "seneca-common/features/subscriptions/state";
import { DEFAULT_CREATED_SUBSCRIPTION_ID } from "seneca-common/features/subscriptions/state/consts";
import { ReceivedSubscriptionType } from "seneca-common/features/subscriptions/state/types";

import { handleCreditCardFormSubmit } from "../actions/handleCreditCardFormSubmit";

type OwnProps = {
  subscriptionId?: string;
  stripe: Stripe;
  stripeElements: StripeElements;
  errorMessage: string | null | undefined;
  stripeErrorMessage: string | null | undefined;
  subscriptionProductId: string;
  addonProductIds: string[];
  onCreateSubscriptionStart: (() => void) | null | undefined;
  onCreateSubscriptionSuccess: (subscription: {
    oldSubscription: ReceivedSubscriptionType;
  }) => void;
  onSubmitFailure: (message: string | null | undefined) => void;
  onRetryPaymentRequired: (message: string | null | undefined) => void;
};

type StateProps = {
  errorMessage: string | null | undefined;
  onCreateSubscriptionSuccess: (subscription: {
    oldSubscription: ReceivedSubscriptionType;
  }) => void;
  onSubmitFailure: (message: string | null | undefined) => void;
};

type DispatchProps = {
  onCreditCardFormSubmit: (cardHolderEmail?: string) => Promise<void>;
};

export type InjectedProps = DispatchProps;

const mapStateToProps = (
  state: any,
  {
    errorMessage,
    stripeErrorMessage,
    onCreateSubscriptionSuccess,
    onSubmitFailure
  }: OwnProps
): StateProps => {
  return {
    errorMessage:
      errorMessage ||
      stripeErrorMessage ||
      (createSubscriptionErrored(state, DEFAULT_CREATED_SUBSCRIPTION_ID)
        ? createSubscriptionErrorMessage(state, DEFAULT_CREATED_SUBSCRIPTION_ID)
        : null),
    onCreateSubscriptionSuccess,
    onSubmitFailure
  };
};

const mapDispatchToProps = (
  dispatch: any,
  {
    subscriptionId,
    stripe,
    stripeElements,
    subscriptionProductId,
    addonProductIds,
    onCreateSubscriptionStart,
    onCreateSubscriptionSuccess,
    onSubmitFailure,
    onRetryPaymentRequired
  }: OwnProps
): DispatchProps => ({
  onCreditCardFormSubmit: async (cardHolderEmail?: string, postcode?: string) =>
    await dispatch(
      handleCreditCardFormSubmit({
        subscriptionId,
        subscriptionProductId,
        addonProductIds,
        cardHolderEmail,
        postcode,
        options: {
          stripe,
          stripeElements,
          onStart: onCreateSubscriptionStart!,
          onSuccess: ({ oldSubscription }) => {
            onCreateSubscriptionSuccess &&
              onCreateSubscriptionSuccess({ oldSubscription });
          },
          onError: onSubmitFailure,
          onRetryPaymentRequired
        }
      })
    )
});

const withHandleCreditCardFormSubmit = connect(
  mapStateToProps,
  mapDispatchToProps
);

export { withHandleCreditCardFormSubmit };
